export default __webpack_public_path__ + "static/branding4-d95777867425765ff60f1bc71b88067a.webp";